import { supabase } from '@/core/supabaseClient';
import type { WorkoutHistoryItem } from '../types';

/** Loads workout rows for a signed-in user from Supabase (best-effort; empty on failure). */
export async function fetchWorkoutsRows(userId: string): Promise<WorkoutHistoryItem[]> {
  try {
    const { data, error } = await supabase
      .from('workouts')
      .select('*')
      .eq('user_id', userId)
      .order('created_at', { ascending: false });

    if (error) {
      console.warn('Workouts table notice:', error.message);
      return [];
    }
    return (data ?? []) as WorkoutHistoryItem[];
  } catch (err) {
    const message = err instanceof Error ? err.message : String(err);
    console.warn('Workouts table notice:', message);
    return [];
  }
}
